import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import SettingsIcon from '@material-ui/icons/SettingsOutlined';
import Checkbox from '@material-ui/core/Checkbox';
import { Form, Formik } from 'formik';
import React from 'react';
import styled from 'styled-components';
import ProjectsContext from './ProjectsContext';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';

const Container = styled.div`
    // position: relative;
  
`;

const TitleContainer = styled.div`
    display:flex;
    align-items:center;
    padding-left:10px;
    width:100%;
    height:64px;
    justify-content:space-between;
`;
const Title = styled.div`
color: rgba(0, 0, 0, 0.87);
font-family: Roboto;
font-size: 17px;
font-weight: 500;
letter-spacing: 0.25px;
line-height: 24px;
text-align: left;

`;

const ProjectNameContainer = styled.div`
    // width: 200px;
    color: rgba(0, 0, 0, 0.87);
    font-family: Roboto;
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 0.25px;
   
    margin-left:25px;
    margin-top: 10px;
    margin-bottom:10px;
    display:flex;
    // justify-content:left;
    justify-content:space-between;
    align-items:center;
`;
class ProjectFunctionsList extends React.Component {
    
    static contextType = ProjectsContext;

    constructor(props) {
        super(props);
        this.formikProps = null;
        this.handleBeforeUnload = this.handleBeforeUnload.bind(this);
        this.state = {
            sanitizedFunctions: null,
            sanitizedSignature: null,
        };
    }

    componentDidMount() {
        window.addEventListener('beforeunload', this.handleBeforeUnload);
        this.updateSanitizedFunctionsIfNeeded();
    }

    componentWillUnmount() {
        window.removeEventListener('beforeunload', this.handleBeforeUnload);
        this.formikProps = null;
        if (typeof this.context.setWorkflowPendingChanges === 'function') {
            this.context.setWorkflowPendingChanges(false);
        }
    }

    handleBeforeUnload(event) {
        if (!this.hasUnsavedChanges()) {
            return;
        }

        event.preventDefault();
        event.returnValue = 'Work done is unsaved';
        return 'Work done is unsaved';
    }

    hasUnsavedChanges() {
        const hasPendingSelections = Boolean(this.context.pendingFunctionSelections);
        const formIsDirty = Boolean(this.formikProps && this.formikProps.dirty);
        const workflowHasPendingChanges = Boolean(this.context.workflowHasPendingChanges);
        return hasPendingSelections || formIsDirty || workflowHasPendingChanges;
    }

    handleNavigateBack(formProps) {
        if (this.hasUnsavedChanges()) {
            const shouldLeave = window.confirm('Work done is unsaved. Do you want to leave without saving?');
            if (!shouldLeave) {
                return;
            }
        }

        formProps.resetForm();
        this.context.clearPendingFunctionSelections();
        if (typeof this.context.setWorkflowPendingChanges === 'function') {
            this.context.setWorkflowPendingChanges(false);
        }
        this.context.displayFunctionList(false);
        this.context.reduxStore.selectedFunctionDetails = null;
        this.context.reduxStore.selectedProjectOrGbu = null;
    }

    componentDidUpdate() {
        this.updateSanitizedFunctionsIfNeeded();
    }

    updateSanitizedFunctionsIfNeeded() {
        const { selectedProjectOrGbu } = this.context.reduxStore;
        const functionsMissingPrimary = this.context.functionsMissingPrimary || {};

        if (!selectedProjectOrGbu || selectedProjectOrGbu.isGbu) {
            if (this.state.sanitizedFunctions || this.state.sanitizedSignature) {
                this.setState({ sanitizedFunctions: null, sanitizedSignature: null });
            }
            return;
        }

        const rawFunctions = Array.isArray(selectedProjectOrGbu.initialFunctionFormValues)
            ? selectedProjectOrGbu.initialFunctionFormValues
            : [];

        if (!rawFunctions.length || !Object.keys(functionsMissingPrimary).length) {
            if (this.state.sanitizedFunctions || this.state.sanitizedSignature) {
                this.setState({ sanitizedFunctions: null, sanitizedSignature: null });
            }
            return;
        }

        let requiresSanitization = false;
        const sanitizedFunctions = rawFunctions.map((fn) => {
            if (!fn || !fn.id) {
                return fn;
            }

            const isMissingPrimary = Boolean(functionsMissingPrimary[fn.id]);
            if (isMissingPrimary && fn.isChecked) {
                requiresSanitization = true;
                return { ...fn, isChecked: false };
            }

            return fn;
        });

        if (!requiresSanitization) {
            if (this.state.sanitizedFunctions || this.state.sanitizedSignature) {
                this.setState({ sanitizedFunctions: null, sanitizedSignature: null });
            }
            return;
        }

        const signature = JSON.stringify(sanitizedFunctions);

        if (signature === this.state.sanitizedSignature) {
            return;
        }

        this.setState({ sanitizedFunctions, sanitizedSignature: signature });
    }

    async handleFunctionToggle(formProps, index) {
        const { selectedProjectOrGbu } = this.context.reduxStore;
        const functionsMissingPrimary = this.context.functionsMissingPrimary || {};

        const currentFunction = formProps.values.functions[index];
        const nextChecked = !currentFunction.isChecked;

        if (nextChecked && functionsMissingPrimary[currentFunction.id]) {
            if (typeof this.context.showSnackBarMessage === 'function') {
                this.context.showSnackBarMessage('Add a primary approver to enable this function.');
            }

            if (!selectedProjectOrGbu?.isGbu) {
                await this.context.selectFunction(currentFunction);
                this.context.displayWorkflowDialog();
            }

            return;
        }

        const updatedFunctions = formProps.values.functions.map((aFunction, fnIndex) => (
            fnIndex === index ? { ...aFunction, isChecked: nextChecked } : aFunction
        ));

        formProps.setFieldValue('functions', updatedFunctions);
        formProps.setFieldTouched(`functions.${index}.isChecked`, true, false);

        this.context.setPendingFunctionSelections(updatedFunctions);

        if (!selectedProjectOrGbu?.isGbu) {
            const toggledFunctionData = updatedFunctions[index];
            const fallbackFunction = updatedFunctions.find((fn) => fn.isChecked);

            const functionToShow = toggledFunctionData.isChecked ? toggledFunctionData : fallbackFunction;

            if (functionToShow) {
                await this.context.selectFunction(functionToShow);
                this.context.displayWorkflowDialog();
            } else {
                this.context.clearPendingFunctionSelections();
                this.context.closeWorkflowDialog();
            }
        }

        if (selectedProjectOrGbu?.id) {
            this.context.saveProjectFunctions({ functions: updatedFunctions, projectId: selectedProjectOrGbu.id });
        }
    }

    handleFunctionRowClick(formProps, index) {
        const { selectedProjectOrGbu } = this.context.reduxStore;

        if (!selectedProjectOrGbu || selectedProjectOrGbu.isGbu) {
            return;
        }

        const clickedFunction = formProps.values.functions[index];

        if (!clickedFunction) {
            return;
        }

        this.context.selectFunction(clickedFunction);
        this.context.displayWorkflowDialog();
    }

    renderList()
    {
        const {selectedProjectOrGbu,selectedFunction = {}} = this.context.reduxStore;

        return <div style={{minHeight: 'calc(100vh - 315px)'}}><List>
            {selectedProjectOrGbu && selectedProjectOrGbu.functions && selectedProjectOrGbu.functions.map(aFunction => <ListItem 
                            key={aFunction.id}
                            divider 
                            button 
                            onClick={()=>this.context.selectFunction(aFunction)}
                            selected={selectedFunction && selectedFunction.id === aFunction.id} 
                        > 
                     <ListItemText primary={aFunction.name}/>
                    </ListItem>)
            }
        </List></div>
    }

    renderFormList(formProps)
    {
        const { values } = formProps;
        const { selectedFunction } = this.context.reduxStore;
        const functionsMissingPrimary = this.context.functionsMissingPrimary || {};
        return <div style={{minHeight: 'calc(100vh - 275px)'}}><List>
            {values.functions.map((aFunction,index) => {
                const isMissingPrimary = Boolean(functionsMissingPrimary[aFunction.id]);
                const isChecked = Boolean(aFunction.isChecked);
                const isSelected = selectedFunction && selectedFunction.id === aFunction.id;
                return (
                    <ListItem
                        key={aFunction.id || index}
                        divider
                        button
                        onClick={() => this.handleFunctionRowClick(formProps, index)}
                        selected={isSelected}
                    >
                        <ListItemIcon
                            style={{minWidth:33}}
                            title={isMissingPrimary ? 'Assign required primary approvers to enable this function.' : undefined}
                        >
                            <Checkbox
                                color="primary"
                                disabled={true}
                                checked={isChecked}
                                onClick={(event) => event.stopPropagation()}
                                onChange={() => this.handleFunctionToggle(formProps, index)}
                                disableRipple
                            />
                        </ListItemIcon>
                        <ListItemText primary={aFunction.name}/>
                    </ListItem>
                );
            })
            }
        </List></div>
    }

    renderContent(formProps)
    {
        const {selectedProjectOrGbu} = this.context.reduxStore;
        const isGbu = selectedProjectOrGbu.isGbu;

        return(
        <Form>
            <Container> 
                <TitleContainer>            
            {   <Title>
                    <IconButton style={{paddingLeft:15}} color="primary" onClick={() => this.handleNavigateBack(formProps)}>
                        <ArrowBackIosIcon/>
                        </IconButton>
                    {selectedProjectOrGbu.isGbu ? 'GBU Workflows' : 'Projects'}
                </Title>}               
                
            </TitleContainer>
            <Divider/>
            <ProjectNameContainer>
                <div style={{width:'75%'}}>
                    {selectedProjectOrGbu && selectedProjectOrGbu.preferredName ? selectedProjectOrGbu.preferredName : selectedProjectOrGbu.name}
                </div>
                
                <div style={{width:'25%'}}>
                    {!isGbu &&
                     (this.context.aboutCurrentUser.isOM || this.context.aboutCurrentUser.isAdmin  || this.context.aboutCurrentUser.isGbuAdmin) &&
                        <IconButton color="primary" onClick={() => {
                            this.context.displayProjectCustomNameDialog();
                            
                            
                        }
                        }>
                        <SettingsIcon/>
                        </IconButton>
                    }
                </div>
                 
            </ProjectNameContainer>  
            <Divider/>
            {isGbu ? this.renderList() : this.renderFormList(formProps)}
            
            </Container>
        </Form>)
    }

    render()
    {
             const {selectedProjectOrGbu} = this.context.reduxStore;
                         const {initialFunctionFormValues = []} = selectedProjectOrGbu ? selectedProjectOrGbu : {};
                         const initialFunctionsForForm = this.state.sanitizedFunctions || initialFunctionFormValues;
       return <Formik
       enableReinitialize
                initialValues={{functions:initialFunctionsForForm}}
                onSubmit={(values, { setSubmitting }) => {
                    if (!selectedProjectOrGbu?.id) {
                        return;
                    }
                    this.context.saveProjectFunctions({functions:values.functions,projectId:selectedProjectOrGbu.id});
        }}  
      >  
            {formProps => {
                if (selectedProjectOrGbu) {
                    this.formikProps = formProps;
                } else {
                    this.formikProps = null;
                }

                return selectedProjectOrGbu ? this.renderContent(formProps) : <div/>;
            }}
      </Formik>
    }
}

export default ProjectFunctionsList;
